import React from 'react';
import { TAP } from '../utils/layoutMode';

// ── "BEST ON A TABLET OR COMPUTER" ──────────────────────────────────────────
//
// What a heavy office screen shows in Field Mode: the numbers, read-only, and
// one line saying where to open the real thing.
//
// ⚠ A SUMMARY, NOT A BLOCK, AND THE DIFFERENCE IS THE WHOLE POINT. "Not
// available on mobile" is the message that makes somebody drive back to the
// office to read one figure. Everything worth knowing is HERE; only the
// EDITING is withheld, and the screen names the device to use rather than
// leaving it as a shrug.
//
// ⚠ AND IT IS NEVER A LIE ABOUT CAPABILITY. The reason is always concrete —
// "it is a wide grid of quantities and overrides" — because "optimised for
// desktop" is the kind of sentence that reads as an excuse.
export default function BestOnLargerScreen({ what, why, children, onOpenAnyway }) {
  return (
    <div style={{ padding: '14px 12px 24px', maxWidth: 760, margin: '0 auto' }}>
      <div style={{
        background: 'var(--dark3)', border: '1px solid rgba(243,156,18,0.4)',
        borderRadius: 12, padding: '13px 14px', marginBottom: 14, lineHeight: 1.55,
      }}>
        <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 5 }}>
          📱 {what ? `${what[0].toUpperCase()}${what.slice(1)} is` : 'This is'} best on a tablet or computer
        </div>
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>
          {why || 'It needs more width than a phone has.'} What matters is below, read-only.
        </div>
        {/* ⚠ AN ESCAPE HATCH, because sometimes the only device anybody has is
            the phone and a wide screen is two hours away. It is explicit, it
            warns, and it is not the default. */}
        {onOpenAnyway && (
          <button type="button" onClick={onOpenAnyway}
            style={{
              marginTop: 11, minHeight: TAP, width: '100%', borderRadius: 9,
              background: 'var(--dark2)', border: '1px solid var(--border)',
              color: 'var(--text)', font: 'inherit', fontWeight: 700, fontSize: 13.5, cursor: 'pointer',
            }}>
            Open it anyway — expect to pinch and scroll
          </button>
        )}
      </div>
      {children}
    </div>
  );
}
